import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Building2, LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';
import { logout, getCurrentUser } from '../utils/api';

export const NoCompany = () => {
  const navigate = useNavigate();
  const user = getCurrentUser();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md text-center"
      >
        <div className="bg-white border border-stone-200 rounded-xl p-8">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Building2 className="w-8 h-8 text-amber-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-stone-900 mb-2">No Company Assigned</h1>
          
          <p className="text-stone-600 mb-6">
            Hi {user?.name || 'there'}! Your account hasn't been assigned to a company yet. 
            Please contact your administrator to get access.
          </p>

          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>

        <p className="text-sm text-stone-500 mt-6">
          Need help? Contact your system administrator.
        </p>
      </motion.div>
    </div>
  );
};

export default NoCompany;
